import { withInstall } from "../../utils";
import TzjPlayer from "./src/tzj-player.vue";
export * from "./src/yunzhiyan";

export const ITzjPlayer = withInstall(TzjPlayer); // 增加类型

export default ITzjPlayer;
